// src/web/index.js
import mpx4 from "@mpxjs/core";
import apiProxy from "@mpxjs/api-proxy";

// src/cross-mini-web/webx.js
import {
  getEnvInfo,
  pay,
  trackEvent,
  canIUse,
  initSDK,
  setLoginConfig,
  getOmega,
  init,
  hashQuery,
  query,
  isLogin,
  login,
  goTo,
  bridge,
  locate,
  is,
  xenv,
  setShare,
  invokeShare,
  saveImg
} from "@didi/webx-js";

// src/web/query/index.js
function query2() {
  return {
    ...query(),
    ...hashQuery()
  };
}

// src/web/trackEvent/raven.js
import raven from "@didi/raven";
import ravenErrorPlugin from "@didi/raven/dist/plugins/error";
import ravenPerformancePlugin from "@didi/raven/dist/plugins/performance";
import ravenPageViewPlugin from "@didi/raven/dist/plugins/pageview";
var _hasSetRavenAppId = false;
function initRaven(appId) {
  if (!_hasSetRavenAppId) {
    _hasSetRavenAppId = true;
    raven.use(ravenErrorPlugin);
    raven.use(ravenPerformancePlugin);
    raven.use(ravenPageViewPlugin, {
      autoTrackPageView: false
    });
    raven.setConfig({
      appId
    });
  }
}
function createRavenProxy(method) {
  return (...args) => {
    if (window.__Raven?.appId) {
      initRaven(window.__Raven?.appId);
      return raven[method](...args);
    } else {
      return () => {
      };
    }
  };
}
var _raven = {
  setConfig: createRavenProxy("setConfig"),
  trackRequest: createRavenProxy("trackRequest"),
  trackEvent: createRavenProxy("trackEvent"),
  trackPageView: createRavenProxy("trackPageView"),
  trackError: createRavenProxy("trackError")
};
var raven_default = _raven;

// src/web/utils.js
function baseTrackEvent(label, attrs = {}) {
  const id = "spring_base_event";
  try {
    trackEvent(id, label, attrs);
    raven_default.trackEvent(`${id}(${label})`, attrs);
  } catch (_) {
  }
}
function baseTrackError(label, attrs = {}, error = {}) {
  const errorName = "spring_base_error";
  try {
    const { name, message, stack = "" } = error;
    const errorMessage = name && message ? `${name}: ${message}` : label;
    console.warn(errorMessage);
    getOmega((omega) => {
      omega.trackError(errorName, label, errorMessage, {
        ...attrs,
        stack
      });
    });
    raven_default.trackError(errorName, label, stack, {
      ...attrs,
      errorMessage
    });
  } catch (_) {
  }
}
function getRootDchn() {
  let { pub_root_dchn, dchn } = query2();
  pub_root_dchn = pub_root_dchn || dchn;
  return pub_root_dchn ? { pub_root_dchn } : {};
}

// src/web/login/index.js
var __userInfo = null;
async function getUserInfo() {
  await initLogin();
  return __userInfo;
}
var getUserInfoSync = () => __userInfo;
function isLogin2() {
  baseTrackEvent("isLogin");
  return new Promise((resolve, reject) => {
    try {
      isLogin({ useQuick: true }).then((res) => {
        const { token, uid, phone } = res;
        if (token && uid !== 0 && uid !== "0") {
          __userInfo = {
            phone,
            uid,
            token
          };
          resolve(__userInfo);
        } else {
          __userInfo = {};
          reject(new Error("Not login"));
        }
        baseTrackEvent("isLogin success", {
          __userInfo,
          originDate: res
        });
      }).catch((_) => {
        __userInfo = {};
        baseTrackEvent("isLogin failed");
        reject(new Error("Not login"));
      });
    } catch (error) {
      __userInfo = {};
      baseTrackEvent("isLogin failed");
      reject(new Error("Not login"));
    }
  });
}
function login2() {
  baseTrackEvent("login");
  return new Promise((resolve, reject) => {
    isLogin2().then((res) => {
      __userInfo = res;
      baseTrackEvent("login success", res);
      resolve(res);
    }).catch(() => {
      login().then(({ token, uid, phone }) => {
        __userInfo = {
          uid,
          token,
          phone
        };
        baseTrackEvent("login success", __userInfo);
        resolve(__userInfo);
      }).catch(() => {
        __userInfo = {};
        baseTrackEvent("isLogin failed");
        reject(new Error("Not login"));
      });
    });
  });
}
var initLoginPending = false;
var initLoginQueue = [];
function initLogin() {
  return new Promise((resolve) => {
    if (!getUserInfoSync()) {
      initLoginQueue.push(resolve);
      if (!initLoginPending) {
        initLoginPending = true;
        baseTrackEvent("initLogin");
        isLogin2().catch(() => {
        }).finally(() => {
          if (initLoginQueue.length) {
            initLoginQueue.forEach((req) => req());
            initLoginQueue = [];
            initLoginPending = false;
          }
        });
      }
    } else {
      resolve();
    }
  });
}

// src/web/locate/index.js
var __locationInfo = null;
var getLocationInfo = () => __locationInfo;
async function locate2() {
  baseTrackEvent("locate");
  if (__locationInfo) {
    baseTrackEvent("locate success", {
      ...__locationInfo,
      isCache: true
    });
    return __locationInfo;
  }
  return new Promise((resolve) => {
    if (is2("passenger")) {
      bridge.getLocationInfo({}, (res) => {
        const {
          from_city_name = "",
          from_city_id = "",
          trip_cityid = "",
          from_lng = 0,
          from_lat = 0,
          area = "",
          city_id = "",
          lat = 0,
          lng = 0
        } = res || {};
        __locationInfo = {
          // 定位信息
          cityId: Number(city_id) || -1,
          area,
          lng,
          lat,
          // 上车点信息
          tripCityId: Number(from_city_id || trip_cityid) || -1,
          tripArea: from_city_name,
          tripLng: from_lng,
          tripLat: from_lat
        };
        baseTrackEvent("locate success", {
          ...__locationInfo,
          originDate: res
        });
        resolve(__locationInfo);
      });
    } else if (is2("miniprogram")) {
      const {
        // mini webview携带
        cityid = 0,
        trip_cityid = 0,
        longitude = 0,
        latitude = 0,
        // goto自行拼接
        lng = 0,
        lat = 0,
        cityId = 0,
        tripCityId = 0
      } = query2();
      if (is2("weixin,alipay")) {
        __locationInfo = {
          cityId: Number(cityid || cityId) || -1,
          area: "",
          lng: Number(longitude || lng) || 0,
          lat: Number(latitude || lat) || 0,
          tripCityId: Number(trip_cityid || tripCityId) || -1,
          tripArea: "",
          tripLng: Number(longitude || lng) || 0,
          tripLat: Number(latitude || lat) || 0
        };
        baseTrackEvent("locate success", {
          ...__locationInfo,
          originDate: query2()
        });
        resolve(__locationInfo);
      } else {
        __locationInfo = {
          lat: 0,
          lng: 0,
          cityId: -1,
          area: "",
          tripCityId: -1,
          tripArea: "",
          tripLng: 0,
          tripLat: 0
        };
        baseTrackError("locate", {}, new Error("\u6B63\u5728\u5F15\u7528\u5F53\u524D\u73AF\u5883\u4E0D\u652F\u6301\u7684api === locate ==="));
        resolve(__locationInfo);
      }
    } else {
      locate({
        useQuickOption: "city"
      }).then((locationInfo) => {
        __locationInfo = {
          lng: locationInfo.lng || 0,
          lat: locationInfo.lat || 0,
          cityId: locationInfo.cityId || -1,
          area: "",
          tripCityId: locationInfo.cityId || -1,
          tripArea: "",
          tripLng: locationInfo.lng || 0,
          tripLat: locationInfo.lat || 0
        };
        resolve(__locationInfo);
      }).catch(() => {
        __locationInfo = {
          lat: 0,
          lng: 0,
          cityId: -1,
          area: "",
          tripCityId: -1,
          tripArea: "",
          tripLng: 0,
          tripLat: 0
        };
        resolve(__locationInfo);
      });
    }
  });
}
var initLocatePending = false;
var initLocateQueue = [];
function initLocate() {
  return new Promise((resolve) => {
    if (!getLocationInfo()) {
      initLocateQueue.push(resolve);
      if (!initLocatePending) {
        initLocatePending = true;
        baseTrackEvent("initLocate");
        locate2().finally(() => {
          if (initLocateQueue.length) {
            initLocateQueue.forEach((req) => req());
            initLocateQueue = [];
            initLocatePending = false;
          }
        });
      }
    } else {
      resolve();
    }
  });
}

// src/cross-mini-web/request.js
import mpxFetch from "@didi/mpx-fetch";

// src/cross-mini-web/toast/index.js
import mpx from "@mpxjs/core";
function showToast(params = {}) {
  const {
    title = "",
    icon = "none",
    // success error loading none
    duration = 1500
  } = params;
  return mpx.showToast({
    title,
    icon,
    duration
  });
}
function showLoading(params = {}) {
  const { title = "" } = params;
  return mpx.showLoading({
    title,
    mask: true
  });
}
function hideLoading() {
  mpx.hideLoading();
}

// src/cross-mini-web/request.js
var TIMEOUT = 30 * 1e3;
var DEFAULT_HEADER = {
  "Content-Type": "application/json"
};
var interceptors = {
  response(response) {
    if (response.status === 200) {
      const {
        code,
        errcode,
        errno,
        msg,
        errmsg,
        traceId,
        data
      } = response.data;
      const _code = Number(code ?? errcode ?? errno);
      return Promise.resolve({
        ...response.data,
        code: _code === 0 || _code === 200 ? 200 : _code,
        data: response.data.data,
        msg: msg ?? errmsg,
        traceId: traceId ?? data?.trace ?? data?.traceId
      });
    } else {
      return Promise.resolve({
        code: -100,
        data: null,
        msg: "\u7F51\u7EDC\u5F02\u5E38"
      });
    }
  }
};
var Request = class {
  constructor(config = {}) {
    this.loadingCount = 0;
    this.timeout = config.timeout || TIMEOUT;
    this.header = {
      ...DEFAULT_HEADER,
      ...config.header
    };
    this.xfetch = new mpxFetch.XFetch({
      timeout: this.timeout,
      header: this.header
    });
    this.interceptors = {
      request: {
        use: (onFulfilled) => {
          this.xfetch.interceptors.request.use((config2) => {
            return onFulfilled ? onFulfilled(config2) : config2;
          });
        }
      },
      response: {
        use: (onFulfilled) => {
          this.xfetch.interceptors.response.use((response) => {
            return onFulfilled ? onFulfilled(response) : response;
          }, (err) => {
            const _err = Promise.resolve({
              code: -100,
              data: err.errMsg,
              msg: "\u7F51\u7EDC\u5F02\u5E38"
            });
            return onFulfilled ? onFulfilled(_err) : _err;
          });
        }
      }
    };
    this.interceptors.response.use(interceptors.response);
  }
  setConfig(config = {}) {
    this.timeout = config.timeout || this.timeout;
    this.header = {
      ...this.header,
      ...config.header
    };
  }
  showLoading() {
    if (this.loadingCount === 0) {
      showLoading();
    }
    this.loadingCount++;
  }
  hideLoading() {
    this.loadingCount--;
    if (this.loadingCount === 0) {
      hideLoading();
    }
  }
  async request(url, data = {}, params = {}, options = {}, method, ravenDone) {
    const {
      header = this.header,
      timeout = this.timeout,
      loading = false
    } = options;
    loading && this.showLoading();
    return this.xfetch.fetch({
      url,
      method,
      data,
      params,
      timeout,
      header: {
        ...this.header,
        ...header
      },
      needSign: true
    }).then((_response) => {
      ravenDone && ravenDone(_response.code === 200, _response.traceId, {
        code: _response.code,
        msg: _response.msg
      });
      loading && this.hideLoading();
      return _response;
    });
  }
};

// src/web/is/index.js
function isEnvironment(pattern) {
  const userAgent = navigator.userAgent.toLowerCase();
  return pattern.test(userAgent);
}
var regs = {
  harmonyos: /harmonyos/i
};
var envs = /* @__PURE__ */ new Set(["web"]);
if (!is2("passenger,miniprogram")) {
  envs.add("browser");
}
if (isEnvironment(regs.harmonyos)) {
  envs.add("harmonyos");
}
if (query2().yks_appid === "121735") {
  envs.add("jhalipay");
}
function is2(env) {
  if (env.includes(",")) {
    const conditions = env.split(",");
    return conditions.some((condition) => envs.has(condition) || is(condition));
  }
  if (env.includes(".")) {
    const conditions = env.split(".");
    return conditions.every((condition) => envs.has(condition) || is(condition));
  }
  return envs.has(env) || is(env);
}

// src/web/bridge/index.js
import webview from "@mpxjs/webview-bridge";
var bridge2 = is2("passenger") ? bridge : is2("miniprogram") ? webview : null;

// src/cross-mini-web/storage/index.js
import mpx2 from "@mpxjs/core";
function setStorage(key = "", value = "") {
  return new Promise((resolve) => {
    if (!key) {
      resolve();
      return;
    }
    return mpx2.setStorage({
      key,
      data: value
    });
  });
}
function getStorage(key = "") {
  return new Promise((resolve) => {
    if (!key) {
      resolve(void 0);
      return;
    }
    mpx2.getStorage({
      key,
      success(res) {
        resolve(res.data);
      },
      fail() {
        resolve(void 0);
      }
    });
  });
}
function removeStorage(key = "") {
  return new Promise((resolve) => {
    if (!key) {
      resolve();
      return;
    }
    return mpx2.removeStorage({
      key
    });
  });
}

// src/utils/index.js
function generateUUID() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = Math.random() * 16 | 0;
    const v = c === "x" ? r : r & 3 | 8;
    return v.toString(16);
  });
}

// src/web/request/riskControl.js
var riskControlParams = null;
var riskControlParamsKey = "spring_base_risk_control_params";
function initRiskControlParams() {
  return new Promise((resolve) => {
    try {
      if (riskControlParams) {
        resolve(riskControlParams);
        return;
      }
      if (is2("passenger")) {
        bridge2.getSystemInfo({}, (res) => {
          riskControlParams = {
            imei: res.imei
          };
          resolve(riskControlParams);
        });
      } else {
        getStorage(riskControlParamsKey).then((value) => {
          if (value) {
            riskControlParams = {
              imei: value
            };
          } else {
            const _imei = generateUUID();
            riskControlParams = {
              imei: _imei
            };
            setStorage(riskControlParamsKey, _imei);
          }
          resolve(riskControlParams);
        });
      }
    } catch (_) {
      resolve({});
    }
  });
}
function getRiskControlParams() {
  return riskControlParams || {};
}

// src/web/request/index.js
var __webxParams = null;
function getWebxParams() {
  return __webxParams;
}
function getPublicParams() {
  const _loginParams = getUserInfoSync() || {};
  return {
    ...__webxParams || {},
    ...getRootDchn(),
    ...getRiskControlParams(),
    ...getLocationInfo() || {},
    token: _loginParams.token,
    ticket: _loginParams.token,
    uid: _loginParams.uid
  };
}
var xfetch = new Request();
async function get(url = "", params = {}, options = {}) {
  await Promise.all([
    initLogin(),
    initLocate(),
    initWebx(),
    initRiskControlParams()
  ]);
  const getParams = {
    ...getPublicParams(),
    ...params
  };
  const ravenDone = raven_default.trackRequest(url, getParams);
  return xfetch.request(url, {}, getParams, options, "GET", ravenDone);
}
async function post(url = "", data = {}, options = {}) {
  await Promise.all([
    initLogin(),
    initLocate(),
    initWebx(),
    initRiskControlParams()
  ]);
  if (data instanceof FormData) {
    Object.entries({
      ...getPublicParams()
    }).forEach(([key, value]) => {
      data.append(key, value);
    });
  } else {
    data = {
      ...getPublicParams(),
      ...data
    };
  }
  const ravenDone = raven_default.trackRequest(url, data);
  return xfetch.request(url, data, {
    ...getPublicParams()
  }, options, "POST", ravenDone);
}
var initWebxPending = false;
var initWbexQueue = [];
function initWebx() {
  return new Promise((resolve) => {
    if (!getWebxParams()) {
      initWbexQueue.push(resolve);
      if (!initWebxPending) {
        initWebxPending = true;
        baseTrackEvent("initWebx");
        init({
          initOption: {
            env: "online"
          }
        }).then((_) => {
          baseTrackEvent("initWebx success", _);
          __webxParams = _;
        }).catch(() => {
          baseTrackEvent("initWebx error");
          __webxParams = {};
        }).finally(() => {
          if (initWbexQueue.length) {
            initWbexQueue.forEach((req) => req());
            initWbexQueue = [];
            initWebxPending = false;
          }
        });
      }
    } else {
      resolve();
    }
  });
}

// src/cross-platform/cloneDeep/index.js
import { default as default2 } from "lodash-es/cloneDeep";

// src/cross-platform/debounce/index.js
import { default as default3 } from "lodash-es/debounce";

// src/cross-platform/throttle/index.js
import { default as default4 } from "lodash-es/throttle";

// src/cross-platform/uniqBy/index.js
import { default as default5 } from "lodash-es/uniqBy";

// src/cross-platform/buildSearch/index.js
function buildSearch(params) {
  const serialized = Object.entries(params).filter(([_, value]) => value !== null && value !== void 0).map(([key, value]) => {
    if (typeof value === "object" && value !== null) {
      return `${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(value))}`;
    }
    return `${encodeURIComponent(key)}=${encodeURIComponent(value)}`;
  });
  return serialized.length ? `?${serialized.join("&")}` : "";
}
function buildUrl(url, params) {
  const [origin, existingQuery] = url.split("?");
  const newQuery = buildSearch(params).slice(1);
  if (existingQuery && newQuery) {
    return `${origin}?${existingQuery}&${newQuery}`;
  } else if (newQuery) {
    return `${origin}?${newQuery}`;
  } else {
    return url;
  }
}

// src/cross-platform/countdown/index.js
function countdown(endTime, cb, formatFn) {
  const defaultFormatFn = (milliseconds) => {
    const _unit = (unit) => {
      return unit < 10 ? `0${unit}` : unit.toString();
    };
    let hours = Math.floor(milliseconds / (1e3 * 60 * 60));
    let minutes = Math.floor(milliseconds % (1e3 * 60 * 60) / (1e3 * 60));
    let seconds = Math.ceil(milliseconds % (1e3 * 60) / 1e3);
    if (seconds === 60) {
      minutes++;
      seconds = 0;
    }
    if (minutes === 60) {
      hours++;
      minutes = 0;
    }
    return `${_unit(hours)}:${_unit(minutes)}:${_unit(seconds)}`;
  };
  const formatTime = formatFn || defaultFormatFn;
  let endTimeDate;
  if (typeof endTime === "number") {
    endTimeDate = new Date(Date.now() + endTime * 1e3);
  } else {
    endTimeDate = new Date(endTime.replace(/-/g, "/"));
  }
  if (Number.isNaN(endTimeDate.getTime())) {
    throw new TypeError("Invalid endTime");
  }
  if (endTimeDate <= Date.now()) {
    cb(formatTime(0), true);
    return;
  }
  let intervalId = null;
  const updateCountdown = () => {
    const timeDiff = endTimeDate - Date.now();
    if (timeDiff <= 0) {
      intervalId && clearInterval(intervalId);
      cb(formatTime(0), true);
      return;
    }
    cb(formatTime(timeDiff), false);
  };
  updateCountdown();
  intervalId = setInterval(updateCountdown, 1e3);
  return () => clearInterval(intervalId);
}

// src/web/goto/index.js
import mpx3 from "@mpxjs/core";
function openMini(appId, path, params, envVersion) {
  const formattedPage = path ? buildUrl(path, params) : "";
  if (is2("alipay")) {
    return new Promise((resolve) => {
      const schemeUrl = `alipays://platformapi/startapp?appId=${appId}&page=${formattedPage}`;
      window.location.href = schemeUrl;
      resolve();
    });
  } else {
    return goTo({
      path: "webx-mp-next/transfer-station/index",
      params: {
        type: "jump",
        env_version: envVersion,
        jump_appid: appId,
        jump_path: formattedPage
      }
    });
  }
}
function openH5(url, moveType = "push") {
  if (is2("passenger")) {
    return new Promise((resolve) => {
      bridge2.openPage({ url }, resolve);
    });
  } else if (is2("miniprogram")) {
    const moveTypeMap = {
      push: "navigateTo",
      redirect: "redirectTo",
      replace: "reLaunch"
    };
    const navigationMethod = moveTypeMap[moveType] || "navigateTo";
    return bridge2[navigationMethod]({
      url: `/pages/webview-page/index${buildSearch({ url })}`
    });
  } else {
    location.href = url;
  }
}
function handleSpaNavigation(spaPath, params, moveType) {
  const _loginParams = getUserInfoSync() || {};
  const spaQuery = buildSearch({
    ...getRootDchn(),
    ...getWebxParams() || {},
    ...getLocationInfo() || {},
    token: _loginParams.token,
    uid: _loginParams.uid,
    pre_prod_key: query2().pre_prod_key,
    yks_appid: query2().yks_appid,
    ...params
  });
  const moveTypeMap = {
    push: "navigateTo",
    redirect: "redirectTo",
    replace: "reLaunch"
  };
  return mpx3[moveTypeMap[moveType] || "navigateTo"]({
    url: spaPath + spaQuery
  });
}
function handleMiniProgramNavigation(path, params, moveType) {
  const moveTypeMap = {
    push: 0,
    redirect: 1,
    replace: 2
  };
  return goTo({
    path,
    params,
    extParams: {
      moveType: moveTypeMap[moveType] || 0
    }
  });
}
function handleUrlNavigation(url, params, moveType) {
  if (url.includes("https://v.didi.cn/")) {
    const moveTypeMap = {
      push: 0,
      redirect: 1,
      replace: 2
    };
    return goTo({
      url: buildUrl(url, {
        ...getRootDchn(),
        ...getLocationInfo() || {},
        yks_appid: query2().yks_appid,
        ...params
      }),
      extParams: {
        moveType: moveTypeMap[moveType] || 0,
        unlimitedDomain: true
      }
    });
  } else {
    return openH5(buildUrl(url, params), moveType);
  }
}
function goto(options = {}) {
  baseTrackEvent("goto", options);
  const {
    appId,
    path,
    params = {},
    url,
    scheme,
    spaPath,
    moveType = "push",
    envVersion = "release"
  } = options;
  if (spaPath) {
    return handleSpaNavigation(spaPath, params, moveType);
  } else if (appId) {
    return openMini(appId, path, params, envVersion);
  } else if (scheme || url && url.startsWith("OneTravel")) {
    return goTo({ scheme: scheme || url, params });
  } else if (path || url && url.startsWith("/")) {
    return handleMiniProgramNavigation(path, params, moveType);
  } else if (url) {
    return handleUrlNavigation(url, params, moveType);
  } else {
    baseTrackError("goto", options, new Error("Invalid argument: goto options."));
  }
}
function closePage() {
  const locationHref = location.origin + location.pathname + location.search;
  if (document.referrer && document.referrer !== locationHref) {
    return mpx3.navigateBack({ delta: 1 });
  }
  if (is2("passenger")) {
    return bridge2.closePage();
  }
  if (is2("miniprogram")) {
    return bridge2.navigateBack({ delta: 1 });
  }
  return mpx3.navigateBack({ delta: 1 });
}
function goback(delta = 1) {
  if (global?.__mpxRouter?.stack?.length === 1) {
    return closePage();
  }
  return mpx3.navigateBack({ delta });
}

// src/web/makePhoneCall/index.js
function makePhoneCall(params = {}) {
  let { phoneNumber = "" } = params;
  phoneNumber = String(phoneNumber);
  phoneNumber = phoneNumber.replace(/-/g, "");
  if (phoneNumber) {
    window.location.href = `tel:${phoneNumber}`;
  }
}

// src/cross-mini-web/bcAuthorize.js
import { createStore } from "@mpxjs/core";
var xfetch2 = new Request();
var API_HOST = "https://api.udache.com/gulfstream/confucius";
var API_POP_LIST = "/api/privacy/app/popList";
var API_SIGN = "/api/privacy/app/sign";
var authorizeStore = createStore({
  state: {
    doc: {},
    cb: null,
    agreeCb: null,
    disagreeCb: null,
    commonParams: {}
  },
  mutations: {
    setDoc(state, doc = {}) {
      state.doc = doc;
    },
    setCb(state, cb) {
      state.cb = cb;
    },
    setAgree(state, cb) {
      state.agreeCb = cb;
    },
    setDisagree(state, cb) {
      state.disagreeCb = cb;
    },
    savePopParams(state, {
      token,
      scene_str,
      appid,
      caller
    }) {
      state.commonParams = {
        token,
        scene: scene_str,
        appid,
        caller
      };
    }
  },
  actions: {
    getPopList({ commit, state }) {
      return new Promise((resolve) => {
        xfetch2.request(API_HOST + API_POP_LIST, state.commonParams).then(({ code, data }) => {
          if (code === 200) {
            const scene_str = state.commonParams.scene;
            const {
              scene_map,
              doc_map
            } = data;
            const doc_id = scene_map[scene_str];
            if (doc_id && doc_map[doc_id]) {
              commit("setDoc", doc_map[doc_id]);
              commit("setCb", resolve);
            } else {
              resolve();
              state.agreeCb && state.agreeCb();
              authorizeStore.commit("setAgree", null);
              authorizeStore.commit("setDisagree", null);
              authorizeStore.commit("savePopParams", {});
              commit("setDoc", {});
              commit("setCb", null);
            }
          }
        });
      });
    },
    signLegal({ commit, state }, { doc_id }) {
      xfetch2.request(API_HOST + API_SIGN, {
        ...state.commonParams,
        doc_id
      }, {}, {}, "POST").then(({ code }) => {
        if (code === 200) {
          state.cb && state.cb();
          commit("setCb", null);
        }
      });
    }
  }
});
function checkAuth({
  token,
  scene_str,
  appid,
  caller,
  agree,
  disagree
}) {
  authorizeStore.commit("setAgree", agree || null);
  authorizeStore.commit("setDisagree", disagree || null);
  authorizeStore.commit("savePopParams", {
    token,
    scene_str,
    appid,
    caller
  });
  return authorizeStore.dispatch("getPopList");
}

// src/web/checkLegalNotice/index.js
function checkLegalNotice(params = {}) {
  baseTrackEvent("checkLegalNotice", params);
  const {
    scene = "",
    agree = () => {
    },
    disagree = () => {
    }
  } = params;
  return new Promise((resolve) => {
    if (!scene) {
      baseTrackError("checkLegalNotice", params, new Error("Scene is empty."));
      resolve();
      return;
    }
    login2().then((res) => {
      checkAuth({
        token: res.token,
        scene_str: scene,
        appid: is2("weixin") ? 35009 : is2("alipay") ? 35023 : 1e4,
        caller: "yks-spring-mini",
        agree,
        disagree
      }).then(() => {
        baseTrackEvent("checkLegalNotice success");
        resolve();
      });
    }).catch(() => {
      disagree && disagree();
    });
  });
}

// src/web/trackEvent/index.js
var _has_set_omega_city_id = false;
async function trackEvent2(id, label, attrs = {}) {
  await Promise.all([
    initLogin(),
    initLocate()
  ]);
  if (getLocationInfo && !_has_set_omega_city_id) {
    getOmega((omega) => {
      omega.setConfig({
        cityId: getLocationInfo().cityId
      });
    });
    _has_set_omega_city_id = true;
  }
  trackEvent(id, label, {
    ...getRootDchn(),
    ...attrs
  });
  getUserInfoSync().uid && raven_default.setConfig({
    uid: getUserInfoSync().uid
  });
  raven_default.trackEvent(`${id}(${label})`, {
    ...getRootDchn(),
    ...attrs
  });
}
async function trackPageView() {
  await Promise.all([
    initLogin(),
    initLocate()
  ]);
  getOmega((omega) => {
    if (getLocationInfo && !_has_set_omega_city_id) {
      omega.setConfig({
        cityId: getLocationInfo().cityId
      });
      _has_set_omega_city_id = true;
    }
    omega.sendPageView({
      ...getRootDchn()
    });
  });
  getUserInfoSync().uid && raven_default.setConfig({
    uid: getUserInfoSync().uid
  });
  raven_default.trackPageView();
}
function trackError(key, label, attrs = {}, error = {}) {
  try {
    const { name, message, stack = "" } = error;
    const errorMessage = name && message ? `${name}: ${message}` : label;
    getOmega((omega) => {
      omega.trackError(key, label, errorMessage, {
        ...attrs,
        stack
      });
    });
    raven_default.trackError(key, label, stack, {
      ...attrs,
      errorMessage
    });
  } catch (_) {
  }
}

// src/web/setTitle/index.js
function setTitle(title) {
  if (is2("web")) {
    document.title = title;
  }
  if (is2("passenger")) {
    bridge2.setTitle({
      title
    });
  }
}

// src/web/setClipboardData/index.js
function setClipboardData(text) {
  const dummy = document.createElement("textarea");
  document.body.appendChild(dummy);
  dummy.value = text;
  dummy.select();
  document.execCommand("copy");
  document.body.removeChild(dummy);
  return Promise.resolve();
}

// src/web/index.js
function initApp() {
  if (!mpx4.request) {
    mpx4.use(apiProxy, { usePromise: true });
  }
  initSDK({ branch: "passenger" });
  canIUse("setLoginConfig") && setLoginConfig({
    loginType: "trinity",
    productType: "didi",
    offline: false
  });
  initWebx();
  initLogin();
  initLocate();
}
initApp();
export {
  authorizeStore,
  bridge2 as bridge,
  buildSearch,
  buildUrl,
  canIUse,
  checkLegalNotice,
  default2 as cloneDeep,
  closePage,
  countdown,
  default3 as debounce,
  get,
  getEnvInfo,
  getStorage,
  getUserInfo,
  goback,
  goto,
  hideLoading,
  invokeShare,
  is2 as is,
  isLogin2 as isLogin,
  locate2 as locate,
  login2 as login,
  makePhoneCall,
  pay,
  post,
  query2 as query,
  removeStorage,
  saveImg,
  setClipboardData,
  setShare,
  setStorage,
  setTitle,
  showLoading,
  showToast,
  default4 as throttle,
  trackError,
  trackEvent2 as trackEvent,
  trackPageView,
  default5 as uniqBy,
  xenv
};
